import { Box } from '@mui/material';
import { MenuModifiers } from 'components/MenuModifiers/MenuModifiers';
import { useFetchAvailableEdibleMenu } from 'containers/MenuCreationContainer/hooks/use-fetch-available-edible-menu';
import { useFetchAvailableModifiers } from 'containers/MenuModifiersContainer/hooks/use-fetch-available-modifiers';
import { useFetchEdibleStores } from 'containers/StoresContainer/hooks/use-fetch-edible-stores';
import { useFetchMenuModifiers } from 'containers/MenuModifiersContainer/hooks/use-fetch-menu-modifiers';
import React, { FC } from 'react';

interface Props {
  isSuperAdmin: boolean;
}

export const MenuModifiersContainer: FC<Props> = ({ isSuperAdmin }) => {
  useFetchAvailableModifiers();
  useFetchAvailableEdibleMenu();
  useFetchMenuModifiers();
  useFetchEdibleStores();

  return (
    <Box overflow="scroll" width={1}>
      <MenuModifiers isSuperAdmin={isSuperAdmin} />
    </Box>
  );
};

// eslint-disable-next-line import/no-default-export
export default MenuModifiersContainer;
